import { scrollToElement, isElementInViewport } from '../../helpers/scroll-to-element';

export const getQuestionElId = (questionId) => {
  return 'question-' + questionId;
};

export const scrollIfQuestionIsOutOfView = (questionId, space = -25) => {
  const el = document.getElementById(getQuestionElId(questionId));
  if (!isElementInViewport(el)) {
    scrollToElement(el, { space: space });
  }
  // if ((el && window.scrollY > el.offsetTop) || window.innerHeight < el.offsetTop) {
  // }
};

export const getTimerStorageKey = (storageKey) => {
  return `timer-${storageKey}`;
};
